module.exports = "<div class=\"rm-main-container\" parallax [config]=\"{initialValue: -50, ratio: .7}\">\n  <div class=\"rm-filter\">\n    <h1 class=\"rm-title\">\n      David Cocom Basto\n    </h1>\n    <h2 class=\"rm-subtitle\">\n      Software engineer\n    </h2>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/main/main.component.html
// module id = ../../../../../src/app/main/main.component.html
// module chunks = main